import { useTranslation } from 'react-i18next';

import { TrendingValue } from '@/components/TrendingValue/TrendingValue';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import { Support } from '@/services/types/commonResponse';

import styles from './styles.module.css';

interface RowSupportProps {
  index: number;
  openModal: (index: number) => void;
  support: Support;
  windowWidth: number;
  showFilter: boolean;
}

export const RowSupport = ({ index, openModal, support, windowWidth, showFilter }: RowSupportProps) => {
  const { t } = useTranslation();

  const getModeGestionText = () => {
    if (support?.modeGestionLibelle === 'Pilotée A Horizon') {
      return 'Gestion Pilotée à Horizon Retraite';
    } else {
      return `Gestion ${support?.modeGestionLibelle}`;
    }
  };

  const openSupportModal = () => {
    openModal(index);
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'voir plus support',
      event_detail_1: 'picto',
    });
  };

  return (
    <tr className={styles.tableRow} key={support?.supportId}>
      <td className={styles.tableCell}>
        <div className={styles.supportNameCell}>
          <span className={styles.supportName}> {support?.nomSupport}</span>{' '}
          {support?.modeGestion && showFilter && <span className={styles.managementMode}>{getModeGestionText()}</span>}
        </div>
      </td>
      {windowWidth > 1200 && (
        <>
          <td className={styles.tableCell}>
            {support?.nbParts ? (
              t('format.numberFlexible', {
                value: support?.nbParts,
              })
            ) : (
              <span className={styles.unavailableInfo}>{t('common.infoUnavailable')}</span>
            )}
          </td>
          <td className={styles.tableCell}>
            {support?.prm ? (
              <span>{t('format.currencyFlexible', { value: support?.prm })}</span>
            ) : (
              <span className={styles.unavailableInfo}>{t('common.infoUnavailable')}</span>
            )}
          </td>
          <td className={styles.tableCell}>
            {support?.cotation && support?.dateCotation ? (
              <span>
                {t('format.currencyFlexible', { value: support?.cotation })} au{' '}
                {support?.dateCotation.split('-').reverse().join('/')}
              </span>
            ) : (
              <span className={styles.unavailableInfo}>{t('common.infoUnavailable')}</span>
            )}
          </td>
        </>
      )}
      <td className={styles.tableCell}>
        <div className={styles.supportValue}>
          <div className={styles.allocationContainer}>
            <span className={styles.allocationEuroWeight}>
              {typeof support?.allocation === 'number'
                ? t('format.currencyFlexible', { value: support.allocation })
                : t('common.infoUnavailable')}
            </span>{' '}
            <span>
              {typeof support?.poids === 'number' ? (
                <>({t('format.percentFlexible', { value: support.poids })})</>
              ) : (
                `(${t('common.infoUnavailable')})`
              )}
            </span>
          </div>
        </div>
      </td>
      <td className={styles.tableCell}>
        <div className={styles.cellWithAction}>
          {typeof support?.pmvEuro === 'number' ? (
            <TrendingValue value={support?.pmvEuro || 0} secondaryValue={support?.pmvPct || 0} verticalAlign={true} />
          ) : (
            <span className={styles.unavailableInfo}>{t('common.infoUnavailable')}</span>
          )}
          <button className={styles.compositionButton} onClick={openSupportModal}>
            <i className="totem-icon totem-icon-dots" />
          </button>
        </div>
      </td>
    </tr>
  );
};
